import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { asRoundedPercentage } from "@components/Filters/number.js";
import { DomainDesignation } from "@constants";
import DomainIndicatorRow from "@public-client/Components/Program/Program.ScoreCard.DomainIndicatorRow.vue";
import DomainRow from "@public-client/Components/Program/Program.ScoreCard.DomainRow.vue";
export default {
  components: {
    DomainRow,
    DomainIndicatorRow
  },
  filters: {
    asRoundedPercentage
  },
  data() {
    return {};
  },
  computed: {
    facts() {
      const programId = +this.$route.query.programId || 0;
      if (programId > 0) {
        const programFacts = this.$store.getters.stateSummary?.ProgramFacts || [];
        const program = programFacts.find(x => x.ProgramId === programId);
        return program ? program.Facts : [];
      } else {
        return this.$store.getters.stateSummary.Facts;
      }
    },
    domains() {
      return this.$store.state.domains;
    },
    overall() {
      return this.$store.state.overallDomain;
    },
    overallDesignation() {
      return DomainDesignation.getDesignation(this.facts, this.overall);
    },
    overallPointsEarned() {
      let earned = 0;
      this.facts.forEach(x => earned += x.IndicatorPointsEarned);
      return earned;
    }
  },
  methods: {
    showVideoModal(e) {
      e.preventDefault();
      this.$store.dispatch("openVideoModal", true);
    }
  }
};